<template>
  <div>
    <header-applis titre="Personnaliser l'offre à votre profil" sous-titre="Construire son parcours professionnel" index-progression-courante="3"
                   index-progression-secondaire="10"/>
    <choix-competence-repeater :competences="competences" :callback="sauvegarder"/>
    <skip-competences ecrant-suivant="realiseractivite"/>
    <footer-applis ecran-precedent="apprendreseformer" ecran-suivant="activitesquotidiennes" label-suivant="Je ne souhaite pas répondre aux questions"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';
import ChoixCompetenceRepeater from '../../components/ChoixCompetenceRepeater';
import SkipCompetences from '../../components/SkipCompetences';

export default {
  name: 'construireparcours',
  components: {
    SkipCompetences,
    ChoixCompetenceRepeater,
    HeaderApplis,
    FooterApplis
  },
  data() {
    return {
      competences: [{
        niveau: 1,
        valeur: 'J\'émets une/plusieurs idées pour mon parcours professionnel'
      }, {
        niveau: 2,
        valeur: 'Je confronte mon projet aux contraintes socio-économiques et à mes réalités'
      }, {
        niveau: 3,
        valeur: 'Je définis un projet réaliste et réalisable'
      }, {
        niveau: 4,
        valeur: 'Je détermine la/les étape(s) de mise en œuvre pour mon parcours professionnel'
      }]
    }
  },
  methods: {
    competencesTransversales() {
      return this.$store.getters.getCompetencesTansversales;
    },
    sauvegarder(competence) {
      let informations = {};
      Object.assign(informations, this.competencesTransversales());
      informations.construireparcours = competence;
      this.$store.commit('setCompetencesTransversales', informations);
      this.$router.push('realiseractivite');
    }
  }
}
</script>
